import { ExperienceRating } from "./types"

export const FACE_NAMES: ExperienceRating[] = [
  "pouting",
  "frown",
  "meh",
  "smile",
  "grin"
]

export const FACE_NAMES_WITH_NULL_VALUE: ExperienceRating[] = [
  "not-selected",
  ...FACE_NAMES
]

// Accessible labels for screen readers
export const FACE_ARIA_LABELS: Record<ExperienceRating, string> = {
  pouting: "1 - No",
  frown: "2 - Not Likely",
  meh: "3 - Neutral",
  smile: "4 - Maybe",
  grin: "5 - Yes",
  "not-selected": ""
}
